import { render } from "./AddBlogPost.vue?vue&type=template&id=2c58b0f0&scoped=true"
import script from "../js/add-blog-post.js?vue&type=script&lang=js"
export * from "../js/add-blog-post.js?vue&type=script&lang=js"

import "./AddBlogPost.vue?vue&type=style&index=0&id=2c58b0f0&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c58b0f0"]])

export default __exports__